import './App.css';
import './MediaQueries.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import ServicesPg from './Pages/Services';
import Contact from './Pages/Contact';
import GetAQuote from './Pages/GetAQuote';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import ErrorPage from './Pages/ErrorPage';
import ServiceDetail from './Pages/ServiceDetail';
import Blogs from './Pages/Blogs';
import BlogDetail from './Pages/BlogDetail';
import Buyers from './Pages/Buyers';
import Sellers from './Pages/Sellers';
import Sitemap from './Pages/Sitemap';
import ServiceBaldivis from './Pages/ServiceBaldivis';
import ServiceDetailBaldivis from './Pages/ServiceDetailBaldivis';
import ServicesJoondalup from './Pages/ServicesJoondalup';
import ServicesDetailJoondalup from './Pages/ServicesDetailJoondalup';
import ServicesLeederville from './Pages/ServicesLeederville';
import ServiceDetailLeederville from './Pages/ServiceDetailLeedervile';

function App() {
  return (
   <>
   <BrowserRouter>
     <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<ServicesPg/>} />
        <Route path="/contact-us" element={<Contact/>} />
        <Route path="/get-a-quote" element={<GetAQuote/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms-and-conditions" element={<TermsConditions/>} />
        <Route path="/*" element={<ErrorPage/>} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/buyers/:slug" element={<Buyers/>} />
        <Route path="/sellers/:slug" element={<Sellers/>} />
        <Route path="/sitemap" element={<Sitemap/>} />
        <Route path="/services/baldivis" element={<ServiceBaldivis/>} />
        <Route path="/services/baldivis/:slug" element={<ServiceDetailBaldivis/>} />
        <Route path="/services/joondalup" element={<ServicesJoondalup />} />
        <Route path="/services/joondalup/:slug" element={<ServicesDetailJoondalup/>} />
        <Route path="/services/leederville" element={<ServicesLeederville />} />
         <Route path="/services/leederville/:slug" element={<ServiceDetailLeederville />} />
      </Routes>
      <Footer />
      </BrowserRouter>
   </>
  );
}

export default App;